import Head from "expo-router/head";
import { View } from "react-native";
import { Card, Divider, Text } from "react-native-paper";

export default function HealthRoute() {
	const timestamp = new Date().toUTCString();

	return (
		<>
			<Head>
				<title>Healthcheck</title>
				<meta name="robots" content="noindex" />
			</Head>
			<View
				style={{
					flex: 1,
					alignItems: "center",
					justifyContent: "center",
					paddingHorizontal: 24,
				}}
			>
				<Card mode="outlined" style={{ width: "100%", maxWidth: 384 }}>
					<Card.Content>
						<View style={{ gap: 24 }}>
							<View style={{ gap: 4 }}>
								<Text variant="labelSmall">System Status</Text>
								<Text variant="headlineSmall">Health Check</Text>
							</View>

							<View
								style={{
									flexDirection: "row",
									alignItems: "center",
									gap: 12,
								}}
							>
								<View style={{ width: 12, height: 12, borderRadius: 6 }} />
								<Text variant="titleMedium">All systems operational</Text>
							</View>

							<Divider />

							<View style={{ gap: 12 }}>
								<View
									style={{
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<Text variant="bodySmall">Status</Text>
									<Text variant="bodySmall">200 OK</Text>
								</View>
								<View
									style={{
										flexDirection: "row",
										justifyContent: "space-between",
									}}
								>
									<Text variant="bodySmall">Checked at</Text>
									<Text variant="bodySmall">{timestamp}</Text>
								</View>
							</View>
						</View>
					</Card.Content>
				</Card>
			</View>
		</>
	);
}
